import _ from "lodash";
import { environment } from "../../environments/environment";

/** Join API path segments onto the configured apiUrl. */
export function buildUrl(segments: string[]): string {
  return _.trim(`${environment.apiUrl}/${segments.join("/")}`, "/");
}
